import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// Singular
export const createArtisanJobAction = (formData) => ({
  type: actions.CREATE_JARTISAN,
  payload: formData,
});

export const createSingleArtisanJobAction = (formData) => ({
  type: actions.GET_SINGLE_JARTISAN,
  payload: formData,
});

export const updateArtisanJobAction = (id, formData) => ({
  type: actions.UPDATE_JARTISAN,
  payload: {
    id,
    formData,
  },
});

export const updateArtisanApplicantStatusAction = (formData) => ({
  type: actions.UPDATE_JARTISAN_APPLICANT_STATUS,
  payload: formData,
});
// Plural
export const getArtisanJobsAction = (body) => ({
  type: actions.GET_JARTISAN,
  payload : body
});

export const getArtisanJobsPendingAction = (body) => ({
  type: actions.GET_JARTISAN_PENDING,
  payload : body
});

/**
 * Actions that are fired by redux-saga watchers
 */

// Singular
export const createArtisanJobSuccessAction = (job) => ({
  type: actions.CREATE_JARTISAN_SUCCESS,
  payload: job,
});

export const updateArtisanApplicantStatusSuccessAction = (job) => ({
  type: actions.UPDATE_JARTISAN_APPLICANT_STATUS_SUCCESS,
  payload: job,
});

export const updateArtisanJobSuccessAction = (job) => ({
  type: actions.UPDATE_JARTISAN_SUCCESS,
  payload: job,
});
// Plural
export const getArtisanJobsSuccessAction = (ArtisanJobs) => ({
  type: actions.GET_JARTISAN_SUCCESS,
  payload: ArtisanJobs,
});
export const getSingleArtisanJobSuccessAction = (ArtisanJob) => ({
  type: actions.GET_SINGLE_JARTISAN_SUCCESS,
  payload: ArtisanJob,
});

export const getArtisanJobsPendingSuccessAction = (ArtisanJobs) => ({
  type: actions.GET_JARTISAN_PENDING_SUCCESS,
  payload: ArtisanJobs,
});

export const deleteJobAction = (id) => ({
  type: actions.DELETE_JARTISAN,
  payload: id,
});

export const deleteJobSuccessAction = (jobId) => ({
  type: actions.DELETE_JARTISAN_SUCCESS,
  payload: jobId,
});


/**
 * Misc
 */
export const setArtisanJobsIsLoadingAction = (isLoading) => ({
  type: actions.SET_JARTISAN_IS_LOADING,
  payload: isLoading,
});

export const setArtisanJobsCountAction = (count) => ({
  type: actions.SET_JARTISAN_COUNT,
  payload: count,
});

export const setSearchValueAction = value => ({
  type : actions.SET_AT_SEARCH_VALUE,
  payload : value
})